export default __webpack_public_path__ + "static/media/third.3ea95633.jpg";